import React, { memo, useEffect } from "react";
import { Button, useMutation, useNotify } from "react-admin";
import { useForm } from "react-final-form";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";

interface CalculationButtonProps {
  invalid: boolean;
  setResultCalculations: any;
  setIsLoaded: (isLoaded: boolean) => void;
  setIsCalculationButtonClicked: (isLoaded: boolean) => void;
  formData: formUpdateCcaSchedule;
}

const CalculationButton = ({
  invalid,
  setResultCalculations,
  setIsLoaded,
  setIsCalculationButtonClicked,
  formData,
}: CalculationButtonProps) => {
  const notify = useNotify();
  const formValues = useForm().getState().values;

  const isFixedLocationMonday =
    formValues.isMonday && formValues.dropOffType === "fixed_location";
  const isFixedLocationTuesday =
    formValues.isTuesday && formValues.dropOffType === "fixed_location";
  const isFixedLocationWednesday =
    formValues.isWednesday && formValues.dropOffType === "fixed_location";
  const isFixedLocationThursday =
    formValues.isThursday && formValues.dropOffType === "fixed_location";
  const isFixedLocationFriday =
    formValues.isFriday && formValues.dropOffType === "fixed_location";

  let fixedLocationMondayId = formValues.fixedLocationMondayId;
  let fixedLocationTuesdayId = formValues.fixedLocationTuesdayId;
  let fixedLocationWednesdayId = formValues.fixedLocationWednesdayId;
  let fixedLocationThursdayId = formValues.fixedLocationThursdayId;
  let fixedLocationFridayId = formValues.fixedLocationFridayId;
  if (formValues.isUseOneFixedLocation === true) {
    fixedLocationMondayId = formValues.fixedLocationId;
    fixedLocationTuesdayId = formValues.fixedLocationId;
    fixedLocationWednesdayId = formValues.fixedLocationId;
    fixedLocationThursdayId = formValues.fixedLocationId;
    fixedLocationFridayId = formValues.fixedLocationId;
  }

  useEffect(() => {
    setIsLoaded(false);
    setIsCalculationButtonClicked(false);

    delete formData.commercialDocumentTags;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formData.studentId,
    formData.ccaAcademicYearId,
    formData.ccaStartedAt,
    formData.ccaEndedAt,
    formData.dropOffType,
    formData.fixedLocationId,
    formData.isMonday,
    formData.fixedLocationMondayId,
    formData.waveMondayId,
    formData.isTuesday,
    formData.fixedLocationTuesdayId,
    formData.waveTuesdayId,
    formData.isWednesday,
    formData.fixedLocationWednesdayId,
    formData.waveWednesdayId,
    formData.isThursday,
    formData.fixedLocationThursdayId,
    formData.waveThursdayId,
    formData.isFriday,
    formData.fixedLocationFridayId,
    formData.waveFridayId,
    formData.postalCode,
    formData.street,
    formData.isUseOneFixedLocation,
  ]);

  const [HandleCalculationCost, { loading }] = useMutation(
    {
      type: "create",
      resource: "costPreview/updateCcaSchedule",
      payload: {
        data: {
          studentId: formValues.studentId,
          ccaAcademicYearId: formValues.ccaAcademicYearId,
          startedAt: formValues.ccaStartedAt,
          endedAt: formValues.ccaEndedAt,
          isTaking: true,
          isFromStudentRenewal: true,
          dropOffType: formValues.dropOffType,
          detail: {
            isMonday: formValues.isMonday ? true : false,
            fixedLocationMondayId: isFixedLocationMonday
              ? fixedLocationMondayId
              : null,
            waveMondayId: isFixedLocationMonday
              ? formValues.waveMondayId
              : null,
            isTuesday: formValues.isTuesday ? true : false,
            fixedLocationTuesdayId: isFixedLocationTuesday
              ? fixedLocationTuesdayId
              : null,
            waveTuesdayId: isFixedLocationTuesday
              ? formValues.waveTuesdayId
              : null,
            isWednesday: formValues.isWednesday ? true : false,
            fixedLocationWednesdayId: isFixedLocationWednesday
              ? fixedLocationWednesdayId
              : null,
            waveWednesdayId: isFixedLocationWednesday
              ? formValues.waveWednesdayId
              : null,
            isThursday: formValues.isThursday ? true : false,
            fixedLocationThursdayId: isFixedLocationThursday
              ? fixedLocationThursdayId
              : null,
            waveThursdayId: isFixedLocationThursday
              ? formValues.waveThursdayId
              : null,
            isFriday: formValues.isFriday ? true : false,
            fixedLocationFridayId: isFixedLocationFriday
              ? fixedLocationFridayId
              : null,
            waveFridayId: isFixedLocationFriday
              ? formValues.waveFridayId
              : null,
            doorToDoorAddress:
              formValues.dropOffType === "door_to_door"
                ? {
                    lat: formValues.ccaLocationData?.LATITUDE,
                    lng: formValues.ccaLocationData?.LONGITUDE,
                    street: formValues.street,
                    unitNumber: formValues.unitNumber,
                    blockNumber: formValues.blockNumber,
                    postalCode: formValues.postalCode,
                    building: formValues.building,
                  }
                : null,
          },
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        setResultCalculations(res.json);
        setIsLoaded(true);
        setIsCalculationButtonClicked(true);
      },
      onFailure: (error) => {
        notify(`Failed Calculation Cost, error: ${error.message}`, "warning");
        setResultCalculations([]);
      },
    },
  );

  const CalculationCostButtonStyle = {
    padding: "7px 16px",
  };

  return (
    <Button
      label={loading ? `Loading...` : `Calculation Cost`}
      style={CalculationCostButtonStyle}
      onClick={HandleCalculationCost}
      disabled={invalid}
    >
      <MonetizationOnIcon />
    </Button>
  );
};

export default memo(CalculationButton);
